/**
 * Centralized environment checks. Production mode is "prod".
 * Accepts both "prod" and "production" for compatibility with CRA/Vite build tooling.
 */
const NODE_ENV = process.env.NODE_ENV ?? '';
const LOGIN_MODE = (process.env.REACT_APP_LOGIN_MODE ?? process.env.LOGIN_MODE ?? '').trim().toLowerCase();

export const isProduction = NODE_ENV === 'prod' || NODE_ENV === 'production';
export const isDevelopment = !isProduction;
export const isDevLoginMode = LOGIN_MODE === 'dev';
export const loginMode = isDevLoginMode ? 'dev' : 'default';

export const INITIAL_DOMAIN_URL = (process.env.REACT_APP_INITIAL_DOMAIN_URL ?? process.env.INITIAL_DOMAIN_URL ?? 'https://htns.sg').trim();
